import { defineMessages } from 'react-intl'

const scope = 'app.components.DashboardResolvers'

export default defineMessages({
  titles: {
    name: {
      id: `${scope}.titles.name`,
      defaultMessage: 'Resolvers',
    },
    revenue: {
      id: `${scope}.titles.revenue`,
      defaultMessage: 'Revenue',
    },
    cases: {
      id: `${scope}.titles.cases`,
      defaultMessage: 'Potential Cases',
    },
  },
})
